// extracted by mini-css-extract-plugin
export default {"video":"Videos_video__ZYIBu","video-container":"Videos_video-container__ymEGb"};